import { PortfolioSettingsModel } from "../../../../../portfolio-info/types/PortfolioSettingsModel";
import type { MarketDataDto } from "../../../../../../shared/types/MarketDataDto";
import { BaseChartDataSeriesService } from "../../common/BaseChartDataSeriesService";
import { PortfolioProfile } from "../../../../../../shared/types/PortfolioProfile";
import { balanceProfileTooltipService } from "./BalanceProfileTooltipService";
import { PortfolioPerformanceContext } from "../../../../../../shared/services/PortfolioPerformanceService";

class ChartDataSeriesService extends BaseChartDataSeriesService {
    private readonly  valuePrecision = 2;
    
    getChartBalanceSeries = (
        marketDataDto: MarketDataDto,
        portfolioProfile: PortfolioProfile,
        comparedPortfolioProfile: PortfolioProfile,
        portfolioSettings: PortfolioSettingsModel,
        performanceContext: PortfolioPerformanceContext,
    ): any[] => {
        const series: any[] = [];

        series.push(this.getCurrentBalanceSeries(
            marketDataDto,
            portfolioProfile,
            comparedPortfolioProfile,
            portfolioSettings,
            performanceContext,
        ));
        
        series.push(this.getCustomBalanceSeries(balanceProfileTooltipService.customBalance1Name, this.style.selectedLineWidth * 0.6));
        series.push(this.getCustomBalanceSeries(balanceProfileTooltipService.customBalance2Name, this.style.selectedLineWidth * 0.85));
        series.push(this.getCustomBalanceSeries(balanceProfileTooltipService.customBalance3Name, this.style.selectedLineWidth * 1.1));    
        
        series.push(this.getExpirationBalanceSeries());

        if (portfolioSettings.useComparedPortfolio) {
            series.push(this.getComparedCurrentBalanceSeries());
            series.push(this.getComparedCustomBalanceSeries());
            series.push(this.getComparedExpirationBalanceSeries());
        }

        return series;
    }
    
    private getCurrentBalanceSeries = (
        marketDataDto: MarketDataDto,
        portfolioProfile: PortfolioProfile,
        comparedPortfolioProfile: PortfolioProfile,
        portfolioSettings: PortfolioSettingsModel,
        performanceContext: PortfolioPerformanceContext,
    ) => {
        return {...
            this.getSeries(balanceProfileTooltipService.currentBalanceName, this.style.selectedCurrentLineColour,
                this.style.selectedCurrentLineType, this.style.selectedLineWidth, this.valuePrecision),
            markLine: this.getMarkLines(
                marketDataDto,
                portfolioProfile,
                comparedPortfolioProfile,
                portfolioSettings,
                performanceContext,
            ),
            markArea: this.getMarkAreas(portfolioSettings),
        };
    }

    private getComparedCurrentBalanceSeries = () => this.getSeries(balanceProfileTooltipService.comparedCurrentBalanceName,
        this.style.comparedCurrentLineColour, this.style.comparedCurrentLineType, this.style.comparedLineWidth, this.valuePrecision);

    private getCustomBalanceSeries = (name: string, lineWidth: number) => this.getSeries(name,
        this.style.selectedCustomLineColour, this.style.selectedCustomLineType, lineWidth, this.valuePrecision);

    private getComparedCustomBalanceSeries = () => this.getSeries(balanceProfileTooltipService.comparedCustomBalanceName,
        this.style.comparedCustomLineColour, this.style.comparedCustomLineType, this.style.comparedLineWidth, this.valuePrecision);

    private getExpirationBalanceSeries = () => this.getSeries(balanceProfileTooltipService.expirationBalanceName,
        this.style.selectedExpirationLineColour, this.style.selectedExpirationLineType, this.style.selectedLineWidth, this.valuePrecision);

    private getComparedExpirationBalanceSeries = () => this.getSeries(balanceProfileTooltipService.comparedExpirationBalanceName,
        this.style.comparedExpirationLineColour, this.style.comparedExpirationLineType, this.style.comparedLineWidth, this.valuePrecision);
}

export const chartDataSeriesService = new ChartDataSeriesService();
